export const formatEnd = (endAt: Date) => {
  const d = new Date();
  const diff = differenceInDays(d, endAt);
  if (diff > 1) {
    return `${diff} jours restants`;
  }
  const diffHours = differenceInHours(d, endAt);
  if (diffHours > 24) {
    return "1 jour restant";
  }
  if (diffHours > 1) {
    return `${diffHours}h restantes`;
  }
  return `1h restante`;
};

export const formatBasic = (
  endAt: string,
  lang: "fr" | "en",
  store: "us" | "fr"
) => {
  const d = new Date(endAt);
  const LOCALE = lang === "fr" ? "fr-FR" : "en";
  return d.toLocaleDateString(LOCALE, {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    timeZone: "UTC",
    timeZoneName: store === "us" ? "short" : undefined,
  });
};

export const formatPublicHome = (
  end_at: string | number,
  lang: "fr" | "en",
  store: "us" | "fr"
) => {
  const endAt = new Date(end_at);
  const LOCALE = lang === "fr" ? "fr-FR" : "en";
  const month = endAt.toLocaleDateString(LOCALE, {
    month: "long",
    timeZone: "UTC",
    timeZoneName: store === "us" ? "short" : undefined,
    weekday: "short",
    day: "numeric",
    hour: store === "us" ? "numeric" : undefined,
  });
  const diff = Math.abs(differenceInHours(new Date(), endAt));
  let res = "";
  if (diff <= 24) {
    res = lang === "fr" ? `jusqu'à demain` : "until tomorrow";
  } else if (diff <= 48) {
    res = lang === "fr" ? `jusqu'après-demain` : "until the day after tomorrow";
  } else {
    res = lang === "fr" ? `jusqu'au ${month}` : `until ${month}`;
  }
  return "<b>" + res + "</b>";
};
export const formatNextHome = (
  start_at: string | number,
  end_at: string | number,
  lang: "fr" | "en",
  store: "us" | "fr"
) => {
  const startAt = new Date(start_at);
  const endAt = new Date(end_at);
  const LOCALE = lang === "fr" ? "fr-FR" : "en";
  // const dayEnd = endAt.toLocaleDateString(LOCALE, { weekday: 'long' });
  const dayEnd = endAt.toLocaleDateString(LOCALE, {
    month: "long",
    timeZone: "UTC",
    timeZoneName: store === "us" ? "short" : undefined,
    weekday: "short",
    day: "numeric",
    hour: store === "us" ? "numeric" : undefined,
  });

  const diff = differenceInHours(new Date(), startAt);
  let res = "";
  if (diff <= 24) {
    res =
      lang === "fr" ? `de demain au ${dayEnd}` : `from tomorrow to ${dayEnd}`;
  } else if (diff <= 48) {
    res =
      lang === "fr"
        ? `d'après-demain au ${dayEnd}`
        : `from the day after tomorrow to ${dayEnd}`;
  } else {
    const day = startAt.toLocaleDateString(LOCALE, {
      weekday: "long",
      day: "numeric",
      timeZone: "UTC",
    });

    res = lang === "fr" ? `du ${day} au ${dayEnd}` : `from ${day} to ${dayEnd}`;
  }
  return "<b>" + res + "</b>";
};

export const addDays = (date: Date, days: number) => {
  return new Date(date.getTime() + days * 60000 * 24 * 60);
};

export const differenceInMinutes = (start: Date, end: Date) => {
  const t1 = start.getTime();
  const t2 = end.getTime();
  return Math.floor((t2 - t1) / 1000 / 60);
};

export const differenceInHours = (start: Date, end: Date) => {
  const t1 = start.getTime();
  const t2 = end.getTime();
  return Math.floor((t2 - t1) / 1000 / 60 / 60);
};

export const differenceInDays = (start: Date, end: Date) => {
  const t1 = start.getTime();
  const t2 = end.getTime();
  return Math.floor((t2 - t1) / 1000 / 60 / 60 / 24);
};

export const isWeekend = (date: Date) => {
  const day = date.getDay();
  return day === 6 || day === 0;
};
